export  class ConverterUtils {
    public static convertJsonString(jsonString: string) {
        try {
            return JSON.parse(jsonString);
        } catch (e) {
            // JSON 错误则不转换到 uiData 上
            return undefined;
        }
    }
}
